export default "__VITE_ASSET__rbm1hYc4__"